define('views/modules/questionnaire/responses/response-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'collections/questionnaire/answers',
    // views
    'views/modules/questionnaire/responses/answers/answer-list',
    'views/parts/menu/menu-save-action',
    // templates
    'text!templates/modules/questionnaire/responses/response-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // models
    CAnswers,
    // views
    VAnswerList,
    VMenuSaveAction,
    // templates
    TResponseContent
) {

    var VResponseContent = Backbone.View.extend({

        template: TResponseContent,

        regions: {
            list: "#results-list",
            menu: ".menu-actions"
        },

        initialize: function(opt) {
            opt = opt || {};

            _.extend(this, {
                questionnaire: opt.questionnaire,
                group: opt.group,
                collection: new CAnswers()
            });

            var model = this.model,
                view = this.view = {
                    list: new VAnswerList({
                        collection: this.collection,
                        questionnaire: this.questionnaire,
                        response: this.model,
                    }),
                    menu: new VMenuSaveAction({
                        context: this,
                        onClick: this.onActionClick,
                        onSave: this.onSaveClick,
                        saveText: 'Save',
                        tooltip: {
                            container: this.regions.root,
                        }
                    }),
                };

            if (this.questionnaire.getQuestions().length === 0) {
                this.questionnaire.fetch({
                    context: this,
                    success: function(model) {
                        this.view.list.resetList();
                    }
                });
            }

            this.listenTo(model, {
                    'sync': this.onModelSync
                })
                .listenTo(this.collection, {
                    'change': this.onCollectionChange,
                    'reset': this.onCollectionReset
                });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.model.attributes)));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.list, zone.$list);
                // .assign(view.menu, zone.$menu);

            return this;
        },

        toggleSaveButton: function() {
            this.view.menu.toggleSaveButton(!this.isDirty());
        },

        isDirty: function() {
            return !this.collection.equals(this.collectionCopy);
        },

        /////////////
        // actions //
        ////////////

        onActionClick: function(e) {
            e.preventDefault();
        },

        ////////////
        // events //
        ////////////

        onSaveClick: function() {
            var model = this.model;
            // setting group to check if logged in user is supervisor of the group to add isSupervisor query param to url
            model.setGroup(this.group);
            model.setComments();
            model.save({
                supervisorComments: model.get('supervisorComments')
            }, {
                patch: true,
                context: this,
                success: this.onSuccess
            });
        },

        onSuccess: function() {
            this.trigger('form:success');
        },

        onCollectionReset: function(collection) {
            this.collectionCopy = collection.toJSON();
            this.toggleSaveButton();
        },

        onCollectionChange: function(collection) {
            this.toggleSaveButton();
        },

        onModelSync: function(model) {
            model.setQuestions(this.questionnaire.getQuestions());
            this.collection.reset(model.getAnswersCollection().models);
        },

    });

    return VResponseContent;

});

